import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isAgreementAutoAcknowledgedBroker } from 'common/utils';

import { VerificationPanel, DocumentsForm, SumSub, ZignSec } from '../../_components';

const DocumentsPage = ({ kycVerifier, status, documents, user, interfaceConfig, dispatch }) => {
  const history = useHistory();
  const [redirectChecked, setRedirectChecked] = useState(false);

  // 指定 broker（如 10/229）无需签署反向招揽文档，不做强制跳转
  const agreementAutoAcknowledged = isAgreementAutoAcknowledgedBroker(interfaceConfig?.brokerId);

  // 页面加载时自动检查是否需要跳转到personal_page
  useEffect(() => {
    if (user && interfaceConfig && !agreementAutoAcknowledged) {
      const userStatus = user?.status || '';
      const isSolicitationAcknowledge = user?.isSolicitationAcknowledge || false;
      const isAgreementAcknowledged = user?.isAgreementAcknowledged || false;
      const userCountry = user?.nationality || '';
      const whiteListCountriesSetting = interfaceConfig?.whiteListCountriesSetting || {};
      const isWhiteListEnabled = whiteListCountriesSetting.enabled;
      const whiteListCountries = whiteListCountriesSetting.countries || [];
      const isUserInWhiteList = whiteListCountries.includes(userCountry);

      if (
        !isAgreementAcknowledged ||
        (userStatus !== 'verified' && !(isWhiteListEnabled && isUserInWhiteList) && !isSolicitationAcknowledge)
      ) {
        dispatch({
          type: 'SHOW_NOTIFICATION',
          payload: {
            type: 'error',
            message: 'Action Required',
            description: 'Please Complete Required Document Signatures',
          },
        });
        history.push('/personal_page');
        return;
      }
    }
    setRedirectChecked(true);
  }, [user, interfaceConfig, dispatch, history, agreementAutoAcknowledged]);

  // 重定向检查未完成前不渲染主内容，避免白屏
  if (!redirectChecked) {
    return null;
  }

  return (
    <VerificationPanel captionId="menuDocuments" warningMessageTextId="kycDocumentsMessage">
      {kycVerifier === 'sumsub' && <SumSub />}
      {kycVerifier === 'default' && <DocumentsForm documents={documents} profileStatus={status} />}
      {kycVerifier === 'zignsec' && status === 'verified' && (
        <DocumentsForm documents={documents} profileStatus={status} />
      )}
      {kycVerifier === 'zignsec' && status !== 'verified' && <ZignSec />}
    </VerificationPanel>
  );
};

DocumentsPage.propTypes = {
  kycVerifier: PropTypes.string.isRequired,
  documents: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  interfaceConfig: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(state => {
  const kycVerifier = state.interfaceConfig?.kycSettings?.kyc_verifier || 'default';
  const {
    status,
    passportStatus,
    identificationProofStatus,
    addressProofStatus,
    passportWithFaceStatus,
    additionalDocumentStatus,
  } = state.user.profile;
  return {
    kycVerifier,
    status,
    documents: {
      passportStatus,
      identificationProofStatus,
      addressProofStatus,
      passportWithFaceStatus,
      additionalDocumentStatus,
    },
    user: state.user.profile,
    interfaceConfig: state.interfaceConfig,
  };
})(DocumentsPage);
export { DocumentsPage };
